import {
  BooleanParam,
  JsonParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import React from "react";
import { CALC_TYPE, voteModePriorElection } from "../helpers/config";

/**
 * Vote Mode Boolean Toggle
 * Show {YEAR} vote mode for each bar graph where the vote mode is one of:
 * in_person_early, absentee, on_eday, registered_didnt_vote, unregistered
 * and {YEAR} is a previous election year.
 * e.g. if {YEAR} is 2020, show the vote mode of how people voted in 2020
 *
 * https://targetsmart.atlassian.net/browse/SE-793
 * https://targetsmart.atlassian.net/wiki/spaces/TKP/pages/2972352530/2020+Vote+Mode+Data+Proposal
 *
 **/
export function VoteModeToggle() {
  let [query, setQuery] = useQueryParams({
    vote_mode: withDefault(BooleanParam, false),
    demo_filters: withDefault(JsonParam, [{}]),
  });

  let { vote_mode, demo_filters } = query;

  // If 'voteModePriorElection' is in demo_filters, do not render the toggle
  const hasVoteModePriorElectionFilter = demo_filters.some(
    (filter) => filter.key === voteModePriorElection
  );

  if (hasVoteModePriorElectionFilter) {
    return null;
  }

  return (
    <fieldset className={"d-flex mr-5"}>
      <legend>2020 Vote Mode</legend>
      <div>
        <button
          type="button"
          onClick={() => {
            setQuery({
              vote_mode: true,
              calc_type: CALC_TYPE.VOTE_SHARE, //must be voteShare when Vote Mode is on
            });
          }}
          className={`button ${vote_mode === true ? "selected" : "unselected"}`}
        >
          On
        </button>
        <button
          type="button"
          onClick={() => {
            setQuery({ vote_mode: false });
          }}
          className={`button ${vote_mode === false ? "selected" : "unselected"}`}
        >
          Off
        </button>
      </div>
    </fieldset>
  );
}
